import NavbarView from "@/components/NavbarView.vue";
import MonitorPanelView from "@/modules/monitor-panel/MonitorPanelView.vue";
import { RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "",
    name: "home",
    component: NavbarView,
    redirect: "panel",
    children: [
      {
        path: "",
        name: "panel",
        component: MonitorPanelView,
        meta: {
          title: "Painel | Biodomi",
        },
      },
    ],
  },
];

export default routes;
